import React from "react";

interface ProductSkeletonProps {
  count?: number;
}

const ProductSkeleton: React.FC<ProductSkeletonProps> = ({ count = 4 }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {[...Array(count)].map((_, i) => (
        <div key={i} className="animate-pulse">
          <div className="bg-section-skeleton rounded-2xl aspect-square mb-4"></div>
          <div className="space-y-2">
            <div className="h-4 bg-section-skeleton rounded w-3/4"></div>
            <div className="h-4 bg-section-skeleton rounded w-1/2"></div>
            <div className="h-6 bg-section-skeleton rounded w-1/3"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProductSkeleton;
